import React, { useEffect, useRef, useState } from "react";

//Import Breadcrumb
import { Grid } from "@mui/material";
import { connect, useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { Container } from "reactstrap";
import Breadcrumb from "../../../components/Common/Breadcrumb";
import Label from "../../../components/Common/Label";
import LoadingDialog from "../../../components/Common/LoadingDialog";
import Notification from "../../../components/Common/Notification";
import SearchBar from "../../../components/Common/Searchbar";
import Table from "../../../components/Common/Table";
import TablePageControl from "../../../components/Common/TablePageControl";
import CustomButton from "../../../components/Form/CustomButton";
import CustomIconButton from "../../../components/Form/CustomIconButton";
import CustomSelect2 from "../../../components/Form/CustomSelect2";
import Helpers from "../../../helpers/helpers";
import { deleteShippingRate, exportShippingRate, getGeneral, getShippingListing, getShippingRateListing, resetShippingRateAttachmentState, resetShippingRateState } from "../../../store/actions";
import "../setting.css";
import RenderPopOverButton from "../../../components/Form/RenderPopOverButton.js";
import DeleteModal from "../../../components/Common/DeleteModal.js";


const ProductShippingRatesSetting = ({ title, shipping, delShipping, exportExcel, shippingMethodList, userPermission, shippingMethodDropdown }) => {
  const dispatch = useDispatch()
  const navigate = useNavigate();

  const [loading, setIsLoading] = useState(false);
  const [shippingMethod, setShippingRated] = useState("all");
  const [filterStatus, setFilterStatus] = useState("all");
  const [page, setPage] = useState("1");
  const [length, setLength] = useState("50");
  const [keyword, setSearch] = useState("");
  const [sort, setSorted] = useState("asc");
  const [sort_by, setSortBy] = useState("id");
  const [selectedRow, setSelectedRow] = useState();
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [notification, setNotification] = useState({
    open: false,
    msg: "",
    type: "success",
  });
  const [creatable, setCreatable] = useState(false);
  const [editable, setEditable] = useState(false);
  const [deletable, setDeletable] = useState(false);
  const [exportable, setExportable] = useState(false);
  const searchRef = useRef(keyword);

  useEffect(() => {
    if (userPermission?.length > 0) {
      userPermission?.includes("create-setting") && setCreatable(true);
      userPermission?.includes("edit-setting") && setEditable(true);
      userPermission?.includes("delete-setting") && setDeletable(true);
      userPermission?.includes("export-setting") && setExportable(true);
      !userPermission?.includes("view-setting") && navigate('/not-authorized');
    }
  }, [userPermission])

  useEffect(() => {
    dispatch(resetShippingRateState());
    dispatch(getShippingListing({ length: "", page: 0, keyword: "", status: "", sort: "", sort_by: "", shippingMethod: "all" }))
  }, [])

  useEffect(() => {
    initData();
  }, [page, length, sort, sort_by, filterStatus, shippingMethod]);

  useEffect(() => {
    searchRef.current = keyword;
  }, [keyword]);

  useEffect(() => {
    if (delShipping?.code === "success") {
      setDeleteOpen(false);
      setNotification({
        open: true,
        msg: "Shipping rate deleted successfully",
        type: "success",
      });
      dispatch(resetShippingRateState());
      dispatch(getGeneral());
      setPage("1");
      initData();
    }
    setIsLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [delShipping]);

  useEffect(() => {
    if (exportExcel?.code === "success") {
      setIsLoading(false)
      Helpers.handleDownloadExcelFile(exportExcel?.excel_base64, 'shipping_rates');
      dispatch(resetShippingRateAttachmentState());
    }

  }, [exportExcel]);

  const initData = () => {
    dispatch(getShippingRateListing({
      length: length,
      page: page,
      keyword: searchRef.current,
      status: filterStatus,
      sort: sort,
      sort_by: sort_by,
      shippingMethod: shippingMethod
    }))
  }

  const header = [
    {
      Header: "Shipping method",
      columnID: "id",
      accessor: (cellProps) => {
        return (
          <React.Fragment>
            <div style={{ paddingRight: "5px" }}>{cellProps?.shipping_method_name}</div>
          </React.Fragment>
        )
      },
      disableFilters: true,
      filterable: false,
    },
    {
      Header: "Order amount range",
      columnID: "min_order_amount",
      accessor: (cellProps) => {
        return (
          <React.Fragment>
            {
              cellProps.descriptions?.[0]?.min_order_amount && cellProps.descriptions?.[0]?.max_order_amount &&
              <div style={{ paddingRight: "5px" }}>
                {cellProps.descriptions?.[0]?.min_order_amount && "S$" + cellProps.descriptions?.[0]?.min_order_amount} {cellProps.descriptions?.[0]?.max_order_amount && "- S$" + cellProps.descriptions?.[0]?.max_order_amount}
              </div>
            }
            {!cellProps.descriptions?.[0]?.min_order_amount && !cellProps.descriptions?.[0]?.max_order_amount && <div style={{ paddingRight: "5px" }}>-</div>}
          </React.Fragment>
        )
      }, disableFilters: true,
      filterable: false,
    },
    {
      Header: "Weight range",
      columnID: "min_weight_range",
      accessor: (cellProps) => {
        return (
          <React.Fragment>
            {
              cellProps.descriptions?.[0]?.min_weight_range && cellProps.descriptions?.[0]?.max_weight_range &&
              <div style={{ paddingRight: "5px" }}>
                {cellProps.descriptions?.[0]?.min_weight_range && cellProps.descriptions?.[0]?.min_weight_range + " kg"} {cellProps.descriptions?.[0]?.max_weight_range && "- " + cellProps.descriptions?.[0]?.max_weight_range + " kg"}
              </div>
            }
            {!cellProps.descriptions?.[0]?.min_weight_range && !cellProps.descriptions?.[0]?.max_weight_range && <div style={{ paddingRight: "5px" }}>-</div>}
          </React.Fragment>
        )
      }, disableFilters: true,
      filterable: false,
    },
    {
      Header: "Shipping cost",
      columnID: "price",
      accessor: (cellProps) => {
        return (
          <React.Fragment>
            <div style={{ paddingRight: "5px" }}>{cellProps.descriptions?.[0]?.price && `S$${cellProps.descriptions?.[0]?.price}`}</div>
          </React.Fragment>
        )
      }, disableFilters: true,
      filterable: false,
    },
    {
      Header: "Status",
      columnID: "status",
      accessor: (cellProps) => {
        return (<React.Fragment><Label.StatusByIDLabel label={cellProps?.status} /></React.Fragment>)
      },
      disableFilters: true,
      filterable: false,
    },
    {
      Header: "Action",
      accessor: (cellProps) => {
        return (
          <React.Fragment>
            {editable && <Link to={`/settings-edit-shipping-rate/` + (cellProps.id)}>
              <CustomIconButton
                iconName={'ri-pencil-line'}
                onClick={() => ''}
              />
            </Link>}
            <RenderPopOverButton
              items={[{
                iconName: 'ri-delete-bin-line',
                label: 'Delete',
                color: '#44d62c',
                permission: deletable,
                onClick: () => { setSelectedRow(cellProps); setDeleteOpen(true) }
              }]}
            />
          </React.Fragment>
        )
      },
      position: 'sticky',
      disableFilters: true,
      filterable: false,
      minWidth: 120
    }
  ]

  const resetFilter = () => {
    setPage("1");
    setSearch('');
    searchRef.current = '';
    setFilterStatus(filterStatus === '' ? 'all' : '');
    setShippingRated(shippingMethod === '' ? 'all' : '');
  }

  const handleDelete = () => {
    if (selectedRow?.id) {
      setIsLoading(true);
      dispatch(deleteShippingRate({ id: selectedRow.id }));
    }
  }

  const handleSearch = (text) => {
    setSearch(text);
    setTimeout(() => {
      if (text === searchRef.current) {
        setPage("1");
        initData();
      }
    }, Helpers.searchInterval);
  }

  const dropdown = () => {
    let temp = [{ id: "all", name: "All Shipping Method" }]
    if (shippingMethodDropdown.length > 0)
      shippingMethodDropdown.map((x, idx) =>
        temp.push({ id: x.id, name: x.descriptions?.[0]?.title })
      )
    return temp
  }

  const handleExport = () => {
    let filter = {
      status: filterStatus === 'all' ? '' : filterStatus,
      shipping_method_id: shippingMethod === "all" ? "" : shippingMethod,
      search: keyword
    };
    Object.keys(filter).forEach(key => {
      if (!filter[key] || filter[key] === 'all') {
        delete filter[key];
      }
    });
    dispatch(exportShippingRate({
      sort: sort_by,
      sort_order: sort,
      filter: filter
    }))
    setIsLoading(true)
  }

  const customToolsBar = () => {
    return (
      <Grid container rowSpacing={2} mb={0} paddingBlock={1}>
        <Grid container item sm={12} xs={12} md={10} lg={10} className="d-flex align-items-center" spacing={1}>
          <Grid item lg={3} md={3} xs={12}>
            <SearchBar
              value={keyword}
              setValue={(e) => handleSearch(e)}
            />
          </Grid>
          <Grid item lg={3} md={3} xs={12}>
            <CustomSelect2
              name={"id"}
              valueName={"name"}
              values={shippingMethod || 'all'}
              onChange={(e) => { setPage("1"); setShippingRated(e) }}
              data={dropdown()}
            />
          </Grid>
          <Grid item lg={3} md={3} xs={12}>
            <CustomSelect2 values={filterStatus || 'all'} onChange={(e) => { setPage("1"); setFilterStatus(e) }} data={Helpers.status} />
          </Grid>
          <Grid item lg={3} md={3} xs={12}>
            <CustomButton
              title={'Clear'}
              press={() => resetFilter()}
              height={32}
              backgroundColor={'transparent'}
              textColor={'#7BB9FA'}
            />
          </Grid>
        </Grid>
        {exportable && <Grid item sm={12} xs={12} md={2} lg={2} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'end' } }} alignItems={'center'}>
          <CustomButton
            title={<><i className="ri-download-2-line" style={{ marginRight: 5 }} />Export</>}
            press={() => handleExport()}
            height={32}
            borderRadius={15}
            borderStyle={"1px solid #babcbe"}
          />
        </Grid>}
      </Grid>
    )
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <LoadingDialog open={loading || !shipping?.data} />
        <Container fluid>
          <Notification notification={notification} setNotification={setNotification} />
          <Breadcrumb
            title={title}
            backRoute={'/settings'}
            breadcrumbItems={[{ title: "Settings", link: "/settings" },
            { title: title, link: "#" },
            ]}
          >
            {creatable && <CustomButton
              title={<><i className="ri-add-line" style={{ marginRight: '5px' }} /> Add Shipping Rate</>}
              press={() => navigate("/settings-add-shipping-rate")}
              height={40}
              backgroundColor={'#101010'}
              textColor={'white'}
            />}
          </Breadcrumb>
          {customToolsBar()}
          <Table
            header={header}
            data={shipping && shipping?.data}
            pageSize={length}
            totalPage={shipping && shipping?.last_page}
            customToolsBar={true}
            sort={sort}
            setSorted={setSorted}
            sort_by={sort_by}
            setSortBy={setSortBy}
          />
          <TablePageControl
            length={length}
            setLength={setLength}
            page={page}
            setPage={setPage}
            totalPage={shipping && shipping?.last_page}
          />
          <DeleteModal
            open={deleteOpen}
            close={() => setDeleteOpen(false)}
            submit={() => handleDelete()}
            module={'shipping rate'}
          />
        </Container>
      </div>
    </React.Fragment >
  );
};


function mapStateToProps({ ShippingRate, General, Shipping, Login }) {
  return {
    shipping: ShippingRate.shippingRateListing,
    shippingMethodDropdown: Shipping.shippingListing,
    delShipping: ShippingRate.deleteShippingRate,
    exportExcel: ShippingRate.exportShippingRate,
    userPermission: Login.permissionArry,
    shippingMethodList: General.shipping_methods,
  };
}


export default connect(mapStateToProps)(ProductShippingRatesSetting);
